import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, } from 'react';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { fileUploadSelectorFamily } from '@zurich/common/recoil';
import { Stack } from '../../../atoms';
import { FileInput } from './FileInput';
import { FileUploadPreview } from './FileUploadPreview';
/**
 * Handles files via the fileUploadSelectorFamily selector
 * !!!IMPORTANT!!!: This is the only component that should be used to handle uploads!
 */
export const FileUpload = forwardRef(function FileUpload({ id, disabled, setBundleErrors, buttonText, maxBundleSize, bundleErrors, withPreview = true, maxFileCount, description, buttonSize, ...props }, ref) {
    const { t } = useTranslation();
    const setFiles = useSetRecoilState(fileUploadSelectorFamily(id));
    const canSelectMultipleFiles = maxFileCount === undefined || maxFileCount !== 1;
    const handleChange = (filesAccepted, filesRejected, bundleRejected, event) => {
        if (setBundleErrors) {
            setBundleErrors(bundleRejected);
        }
        setFiles((files) => Array.from(
        // we use Set to eliminate duplicates of the same file object
        // this does not eliminate uploading the same file multiple times
        // but rather having the same exact file object multiple times
        new Set([
            ...(canSelectMultipleFiles ? (files ?? []) : []),
            ...filesAccepted,
            ...filesRejected,
        ])));
        // we do not persist the previous value for now
        event.target.value = '';
    };
    // Empty files on leave
    useEffect(() => () => {
        setFiles(null);
    }, 
    // We only want to call this on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const { value, onChange, ...filteredProps } = props;
    return (_jsxs(Stack, { rowGap: { sx: 0, md: 1.5 }, children: [_jsx(FileInput, { id: id, fileInputRef: ref, onChange: handleChange, disabled: disabled, buttonText: buttonText ??
                    t(`common:button_label.${canSelectMultipleFiles ? 'add_file' : 'select_file'}`), buttonSize: buttonSize, maxBundleSize: maxBundleSize, maxFileCount: maxFileCount, ...filteredProps }), withPreview && (_jsx(FileUploadPreview, { id: id, disabled: disabled, maxBundleSize: maxBundleSize, bundleErrors: bundleErrors, setBundleErrors: setBundleErrors, description: description }))] }));
});
